import type { ReactNode } from 'react';

import type { SharedData } from '~features/integrations/types';

import { useFacebookShare } from './useFacebookShare';

type FacebookShareTriggerProps = {
  pharmacyId: string;
  sharedData: SharedData;
  children: (props: { open: () => void }) => ReactNode;
};

export function FacebookShareTrigger({
  pharmacyId,
  sharedData,
  children,
}: FacebookShareTriggerProps) {
  const { open, modal } = useFacebookShare(pharmacyId, sharedData);

  return (
    <>
      {children({ open })}
      {modal}
    </>
  );
}
